/*
  Sync structure with rails "button" partial!
*/

import React, { PropsWithChildren } from 'react'

type IconVariants =
  | ''
  | '__inactive'
  | '__accent'
  | '__inFrontOfAccent'
  | '__okGreen'
  | '__errorRed' 

interface Props {
  primary?: boolean
  rounded?: boolean
  disabled?: boolean
  forceWhite?: boolean
  noMinWidthOnMobile?: boolean
  className?: string
  href?: string
  onClick?: (e: any) => void
  title?: string
  target?: string
  method?: string
  iconBaseName?: string
  onlyIcon?: boolean
  iconPos?: "start" | "end"
}

const VARIANT_PRIMARY: IconVariants = '__inFrontOfAccent'
const VARIANT_SECONDARY: IconVariants = '__accent'

const Button: React.FC<PropsWithChildren<Props>> = ({  
  className,
  primary,
  disabled,
  href,
  iconBaseName,
  onClick,
  children,
  title,
  target,
  method,
  onlyIcon,
  iconPos,
  noMinWidthOnMobile,
}) => {
  let variant = 'secondary'
  if (primary) variant = 'primary'

  const methodAttributes = method ? { "data-method": method, rel: "nofollow" } : {}
  const targetAttr = target ? { target: target } : {}
  const classNames = [
    "button",
    `button--${variant}`,
    iconPos === 'end' ? 'button--end' : 'button--start',
    onlyIcon ? 'button--onlyIcon' : "",
    noMinWidthOnMobile ? "button--noMinWidthOnMobile" : "",
    className || "",
  ].join(" ")

  const iconVariant = variant === 'primary'
    ? VARIANT_PRIMARY
    : VARIANT_SECONDARY

  const Inner = <>
    {iconBaseName &&
      <span className={`button__icon icon icon--${iconBaseName}${iconVariant}`} />}
    <span className='button__title'>
      <span>{title || children}</span>
    </span>
  </>

  if (disabled) {
    return (
      <span className={classNames}>
        {Inner}
      </span>
    )
  } else {
    return (
      <a className={classNames} href={href} onClick={onClick} {...targetAttr} {...methodAttributes}>
        {Inner}
      </a>
    )
  }
}

export default Button
